<template>
  <div class="content">
    <el-button
      @click="back"
      size="small"
      class="back"
      v-if="cWidth >= 1200"
      icon="el-icon-back"
      >返回</el-button
    >
    <img
      src="https://weixin.gzyks.com/webapp/applet/ecological_index/map.jpg"
      alt="花城赏花地图"
      @load="onLoadImg"
      @mousewheel="bigImg(this)"
      :style="imgStyle"
      @mousedown="imgMove"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: '',
      imgStyle: '',
      deg: 0,
      params: {
        zoom: 1
      },
      monthObj: {
        1: '一',
        2: '二',
        3: '三',
        4: '四',
        5: '五',
        6: '六',
        7: '七',
        8: '八',
        9: '九',
        10: '十',
        11: '十一',
        12: '十二'
      },
      cWidth: 0 //屏幕宽度
    }
  },
  mounted() {
    let currentMOnth = new Date().getMonth() + 1
    document.title = `花城${this.monthObj[currentMOnth] || 0}月赏花地图`
    this.cWidth = document.body.clientWidth
    this.loading = this.$loading({
      lock: true,
      text: '赏花地图加载中',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.2)'
    })
  },
  methods: {
    back() {
      this.$router.back()
    },
    onLoadImg() {
      this.loading.close()
    },
    //pc端放大缩小图片
    bigImg(ev) {
      if (!this.cWidth >= 1200) return
      let e = ev || window.event
      this.params.zoom += e.wheelDelta / 1200
      if (this.params.zoom >= 0.2) {
        this.imgStyle =
          this.imgStyle +
          `transform:scale(${this.params.zoom}) rotateZ(${this.deg}deg);`
      } else {
        this.params.zoom = 0.2
        this.imgStyle =
          this.imgStyle +
          `transform:scale(${this.params.zoom}) rotateZ(${this.deg}deg);`
        return false
      }
    },
    imgMove(e) {
      if (!this.cWidth >= 1200) return
      let oImg = e.target
      let disX = e.clientX - oImg.offsetLeft
      let disY = e.clientY - oImg.offsetTop
      document.onmousemove = (e) => {
        e.preventDefault()
        let left = e.clientX - disX
        let top = e.clientY - disY
        this.imgStyle = this.imgStyle + `left: ${left}px;top: ${top}px;`
      }
      document.onmouseup = (e) => {
        document.onmousemove = null
        document.onmouseup = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'sass:math';
@media screen and (min-width: 350px) and (max-width: 1200px) {
  $designWidth: 1080;
  $designHeight: 1920;
  @function getVw($px) {
    @return math.div($px, $designWidth) * 100vw;
  }
  @function getVh($px) {
    @return math.div($px, $designHeight) * 100vh;
  }
  .content {
    width: getVw(1080);
    height: getVh(1920);
    padding: 0 getVw(40);
    box-sizing: border-box;
    margin: 0 auto;
    display: flex;
    align-items: center;
    img {
      width: getVw(1000);
    }
  }
}
@media screen and (min-width: 1201px) and (max-width: 4000px) {
  $designWidth: 1920;
  $designHeight: 1080;
  @function getVw($px) {
    @return math.div($px, $designWidth) * 100vw;
  }
  @function getVh($px) {
    @return math.div($px, $designHeight) * 100vh;
  }
  .content {
    // width: getVw(1080);
    // height: getVh(1920);
    padding: getVh(30) getVw(40);
    box-sizing: border-box;
    margin: 0 auto;
    img {
      width: 100%;
      // width: 4454px;
      // height: 6838px;
      margin-bottom: getVh(30);
      position: absolute;
      z-index: 22;
      margin-top: 40px;
      cursor: move;
    }
    .back {
      position: fixed;
      top: getVh(30);
      margin-bottom: getVh(30);
    }
  }
}
</style>
